import { useState } from 'react';

function Tooltip(props) {
  const { children, title, description, triggerEvent, customClass, activate } = props;

  const [isVisible, setVisible] = useState(false);
  const onMouseEnter = () => triggerEvent === 'hover' && activate && setVisible(true);
  const onMouseLeave = () => triggerEvent === 'hover' && activate && setVisible(false);

  return (
    <>
      <div onMouseEnter={() => onMouseEnter()} onMouseLeave={() => onMouseLeave()}>
        {children}
      </div>
      {isVisible && (
        <div className={`tooltip__container ${customClass || ''}`}>
          {title && <span className="tooltip__title">{title}</span>}
          <span className="tooltip__description">{description}</span>
        </div>
      )}
    </>
  );
}

export default Tooltip;
